<!--专家委员会-->
<template>
  <div class="common-container">
    <div class="background"></div>
    <Header></Header>

    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
            <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
              <el-row class="middle">
                <el-col class="middleRight">
                  <el-row type="flex" justify="center">
                    <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                      <organization-aside></organization-aside>
                    </el-col>
                    <el-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1"></el-col>
                    <el-col :xs="24" :sm="17" :md="17" :lg="17" :xl="17">
                      <div class="organization-info-box">
                        <div class="organization-info-title">专家委员会</div>
                        <div class="organization-info-text">To Be Announced...</div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="2" :xl="2"></el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <!-- <div  class="common-main">
      <organization-aside></organization-aside>
      <div class="common-main-artical">
        <h2 class="common-main-title">专家委员会</h2>
        <hr class="common-mainhr">
        <div class="common-main-content">
          <p class="common-main-paragraph">To Be Announced...</p>
        </div>
      </div>
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },

    components: {},

    mounted() {},

    methods: {},

  }

</script>
<style scoped>
.common-main-artical{
  height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/views/Organization/committee.vue